export const SET_EXPRESS_UPGRADE_FEE = 'SET_EXPRESS_UPGRADE_FEE';

export const setExpressUpgradeFee = (expressUpgradeFee) => ({
  type: SET_EXPRESS_UPGRADE_FEE,
  data: {
    expressUpgradeFee,
  },
});
